import Api from "../api";

export default async function apiDeleteTruck(id: string) {
  return await Api.delete<string>({
    input: `/api/v1/truck/${id}`,
  });
}
